import clusterItemConnector from "../cluster-item-connector"

import ClusterEditItem from "./ClusterEditItem"

export default clusterItemConnector(ClusterEditItem)
